(function () {
  'use strict';
  var G = window.Glowdle || { routes: { cart_add_url: '/cart/add', cart_url: '/cart' }, moneyFormat: '${{amount}}' };

  function formatMoney(cents) {
    var fmt = G.moneyFormat || '${{amount}}';
    cents = Math.round(Number(cents) || 0);
    function withDelims(n, decimals, thou, dec) {
      var parts = (n / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
      return parts[0] + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }
  G.formatMoney = formatMoney;

  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('GlowToast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 3200);
  }
  G.toast = toast;

  function addToCart(items) {
    return fetch(G.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    });
  }

  /* marquee: duplicate items for a seamless loop */
  document.querySelectorAll('[data-marquee]').forEach(function (el) {
    el.innerHTML += el.innerHTML;
  });

  /* mobile menu */
  document.querySelectorAll('[data-burger]').forEach(function (btn) {
    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
    });
  });

  /* product sections */
  document.querySelectorAll('[data-glow-product]').forEach(function (root) {
    /* gallery */
    var slides = root.querySelectorAll('.gal-slide');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var count = root.querySelector('[data-gal-count]');
    var gi = 0;
    function show(i) {
      if (!slides.length) return;
      gi = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === gi);
        if (k !== gi) { var v = s.querySelector('video'); if (v) v.pause(); }
      });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === gi); });
      if (count) count.textContent = (gi + 1) + ' / ' + slides.length;
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = root.querySelector('[data-gal-prev]');
    var next = root.querySelector('[data-gal-next]');
    if (prev) prev.addEventListener('click', function () { show(gi - 1); });
    if (next) next.addEventListener('click', function () { show(gi + 1); });

    var form = root.querySelector('[data-product-form]');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[data-qty]');
    var priceEl = root.querySelector('[data-unit-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var totalEl = root.querySelector('[data-total]');
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
    var addons = Array.prototype.slice.call(root.querySelectorAll('[data-addon]'));
    var variantData = [];
    try { variantData = JSON.parse((root.querySelector('[data-variants]') || {}).textContent || '[]'); } catch (e) { variantData = []; }

    function currentVariant() {
      var id = Number(idInput.value);
      for (var i = 0; i < variantData.length; i++) if (variantData[i].id === id) return variantData[i];
      return variantData[0] || null;
    }
    function selectedTier() {
      for (var i = 0; i < tiers.length; i++) if (tiers[i].getAttribute('aria-pressed') === 'true') return tiers[i];
      return null;
    }

    function render() {
      var v = currentVariant();
      if (!v) return;
      var unit = v.price;
      if (priceEl) priceEl.textContent = formatMoney(unit);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > unit) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      tiers.forEach(function (t) {
        var q = Number(t.getAttribute('data-qty-value'));
        var pct = Number(t.getAttribute('data-pct')) || 0;
        var full = unit * q;
        var now = Math.round(full * (100 - pct) / 100);
        var p = t.querySelector('[data-tier-price]');
        var was = t.querySelector('[data-tier-was]');
        var save = t.querySelector('[data-tier-save]');
        if (p) p.textContent = formatMoney(now);
        if (was) was.textContent = formatMoney(full);
        if (save && pct) save.textContent = 'You save ' + formatMoney(full - now);
      });
      var tier = selectedTier();
      var q = tier ? Number(tier.getAttribute('data-qty-value')) : 1;
      var pct = tier ? Number(tier.getAttribute('data-pct')) || 0 : 0;
      qtyInput.value = q;
      var total = Math.round(unit * q * (100 - pct) / 100);
      addons.forEach(function (a) {
        if (a.querySelector('.tog').getAttribute('aria-pressed') === 'true') total += Number(a.getAttribute('data-price'));
      });
      if (totalEl) totalEl.textContent = formatMoney(total);
      if (atc) {
        atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? (atc.getAttribute('data-label') || 'Add to cart') : 'Sold out';
      }
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (o) { o.setAttribute('aria-pressed', o === t); });
        render();
      });
    });
    addons.forEach(function (a) {
      var tog = a.querySelector('.tog');
      tog.addEventListener('click', function () {
        var on = tog.getAttribute('aria-pressed') !== 'true';
        tog.setAttribute('aria-pressed', on);
        tog.textContent = on ? '✓' : '+';
        render();
      });
    });
    var sel = root.querySelector('[data-variant-select]');
    if (sel) sel.addEventListener('change', function () {
      idInput.value = sel.value;
      var v = currentVariant();
      if (v && v.media_index != null) show(v.media_index);
      render();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var items = [{ id: Number(idInput.value), quantity: Number(qtyInput.value) || 1 }];
      addons.forEach(function (a) {
        if (a.querySelector('.tog').getAttribute('aria-pressed') === 'true') items.push({ id: Number(a.getAttribute('data-variant')), quantity: 1 });
      });
      if (atc) atc.classList.add('is-loading');
      addToCart(items).then(function () {
        window.location.href = G.routes.cart_url;
      }).catch(function (err) {
        if (atc) atc.classList.remove('is-loading');
        toast(err.message);
      });
    });

    root.querySelectorAll('[data-gift-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.disabled = true;
        addToCart([{ id: Number(b.getAttribute('data-gift-add')), quantity: 1 }]).then(function () {
          window.location.href = G.routes.cart_url;
        }).catch(function (err) { b.disabled = false; toast(err.message); });
      });
    });

    /* delivery estimate */
    var tl = root.querySelector('[data-timeline]');
    if (tl) {
      var fmt = function (d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); };
      var bizAdd = function (n) { var d = new Date(), k = 0; while (k < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w && w < 6) k++; } return d; };
      var dayAdd = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d; };
      var n = function (k) { return Number(tl.getAttribute(k)) || 0; };
      var d1 = tl.querySelector('[data-d1]'), d2 = tl.querySelector('[data-d2]'), d3 = tl.querySelector('[data-d3]');
      if (d1) d1.textContent = fmt(new Date());
      if (d2) d2.textContent = fmt(bizAdd(n('data-ship-min'))) + ' – ' + fmt(bizAdd(n('data-ship-max')));
      if (d3) d3.textContent = fmt(dayAdd(n('data-del-min'))) + ' – ' + fmt(dayAdd(n('data-del-max')));
    }

    render();
    show(0);
  });

  /* FAQ tabs */
  document.querySelectorAll('[data-faq]').forEach(function (root) {
    var tabsEl = root.querySelector('[data-faq-tabs]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-tab]'));
    var names = [];
    items.forEach(function (it) { var n = it.getAttribute('data-faq-tab'); if (names.indexOf(n) < 0) names.push(n); });
    if (names.length < 2) { if (tabsEl) tabsEl.hidden = true; return; }
    function pick(i) {
      Array.prototype.forEach.call(tabsEl.children, function (b, k) { b.setAttribute('aria-selected', k === i); });
      var first = true;
      items.forEach(function (it) {
        var on = it.getAttribute('data-faq-tab') === names[i];
        it.hidden = !on;
        it.open = on && first;
        if (on) first = false;
      });
    }
    names.forEach(function (n, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('role', 'tab'); b.textContent = n;
      b.addEventListener('click', function () { pick(i); });
      tabsEl.appendChild(b);
    });
    pick(0);
  });

  /* show more */
  document.querySelectorAll('[data-more-btn]').forEach(function (btn) {
    var more = document.getElementById(btn.getAttribute('aria-controls'));
    if (!more) return;
    btn.addEventListener('click', function () {
      var open = more.hidden;
      more.hidden = !open;
      btn.textContent = open ? 'Show less' : 'Show more';
      btn.setAttribute('aria-expanded', open);
    });
  });

  /* cart quantity auto-submit */
  document.querySelectorAll('[data-cart-qty]').forEach(function (inp) {
    inp.addEventListener('change', function () { inp.form.submit(); });
  });
})();
